import React, { forwardRef } from 'react';
import { InfoIcon } from 'lucide-react';
import { Tooltip } from './Tooltip';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  infoTooltip?: string;
  required?: boolean;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  helperText,
  infoTooltip,
  required,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-647">
        {label && <div className="flex items-center mb-2" data-id="element-648">
            <label className="block text-sm font-semibold text-gray-900" data-id="element-649">
              {label}
              {required && <span className="text-red-500 ml-1" data-id="element-650">*</span>}
            </label>
            {infoTooltip && <Tooltip content={infoTooltip} data-id="element-651">
                <button type="button" className="ml-2 text-gray-400 hover:text-[#007AFF] focus:outline-none" data-id="element-652">
                  <InfoIcon className="w-4 h-4" data-id="element-653" />
                </button>
              </Tooltip>}
          </div>}
        <input ref={ref} className={`w-full px-4 py-3 bg-white border-2 rounded-xl outline-none transition-all duration-200 text-gray-900 placeholder-gray-400
            ${error ? 'border-red-300 focus:border-red-500 focus:ring-2 focus:ring-red-200' : 'border-gray-200 focus:border-[#007AFF] focus:ring-2 focus:ring-[#E6F2FF] hover:border-gray-300'} ${className}`} {...props} data-id="element-654" />
        {error && <p className="mt-2 text-sm text-red-500" data-id="element-655">{error}</p>}
        {helperText && !error && <p className="mt-2 text-sm text-gray-500" data-id="element-656">{helperText}</p>}
      </div>;
});
Input.displayName = 'Input';